import { Box, Button, Grid, MenuItem, Stack, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from "react";
import { departmentData } from '../../data/departmentData';
import { useApiClient } from '../../context/ApiClientContext';
import toast from 'react-hot-toast';
import ErrorAlert from "../../helper/errorAlert";
import ComponentBackdrop from '../../components/backdrop';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../helper/baseApi';
import SuccessAlert from '../../helper/successAlert';

const Form = ({ mode, onModeChange, onSuccess, departmentId, departmentDetails }) => {
  const labelWidth = 150;
  const { id: paramId } = useParams();
  const id = departmentId || paramId;
  const [errors, setErrors] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const navigate = useNavigate();

  const [inputForm, setInputForm] = useState({
    id: "",
    department: "",
  });

  useEffect(() => {
    if (mode === "edit" || mode === "view") {
      const department = departmentDetails || {};
      setInputForm(
        {
          ...department,
          department: department.name
        });
    } else {
      setInputForm({
        department: "",
      });
    }
  }, [mode, departmentDetails]);

  const handleInputChange = (property, event) => {
    console.log("value", event.target.value);
    const value = event.target.value;
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const changeEdit = () => {
    onModeChange("edit");
  };

  const submitForm = async () => {
    // reset errors
    let newErrors = {};

    if (!inputForm.department || inputForm.department.trim() === "") {
      newErrors.department = "Department is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // stop submit
    }

    try {
      setOpenBackdrop(true);

      let response = '';
      let apiUrl = '';

      if (mode === 'edit') {
        apiUrl = `${mobileApiUrl}department/update-details`;
        response = await api.put(apiUrl, {
          departmentId: id,
          name: inputForm.department,
        });
      } else {
        apiUrl = `${mobileApiUrl}department/create-department`;
        response = await api.post(apiUrl, {
          name: inputForm.department,
        });
      }

      if (response.status == 200) {
        setTimeout(() => {
          onModeChange(false);
          onSuccess();
          setOpenBackdrop(false);
          SuccessAlert(response.data.message);
        }, 2000);
      }
    } catch (error) {
      ErrorAlert(error, navigate);
      setOpenBackdrop(false);
    }
  };

  const SubmitButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={() => submitForm("Successfully created.")}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
          //   mb: 3,
        }}
      >
        Save
      </Button>
    </Box>
  );
  const EditButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={mode === "edit" ? submitForm : changeEdit}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
        }}
      >
        {mode === "edit" ? "Save" : "Edit"}
      </Button>
    </Box>
  );

  const renderField = (label, id, type = "text", select = false, options = [], disabled = false) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
          minHeight: 50
        }}
      >
        {label}
      </Typography>
      <TextField
        id={id}
        type={type}
        select={select}
        slotProps={{
          input: { readOnly: disabled }
        }}
        error={!!errors[id]}
        helperText={errors[id] || " "}  // <-- space keeps height consistent
        // FormHelperTextProps={{ style: { minHeight: "20px" } }}
        onChange={(e) => handleInputChange(id, e)}
        value={inputForm[id]}
        required
        fullWidth
        size="small"
        variant="outlined"
        autoFocus={id === "department"}
      >
        {select &&
          options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );
  return (
    <Box
      sx={{
        // width: "100%",
        // px: { xs: 3 }, // padding for mobile and desktop
        // pt: { xs: 3},  // vertical padding for mobile and desktop
      }}
    >
      <Box width="100%" display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
        {/* <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "600", textTransform: 'uppercase'  }}>
          {mode === "create" ? "Create New Department" : "Department Details" }
        </Typography> */}
        {mode === "create" ? (
          <SubmitButton />
        ) : (
          <EditButton changeEdit={changeEdit} />
        )}{" "}
      </Box>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid size={{ xs: 12 }}>
          {renderField("Department", "department", "text", false, [], mode === "view")}
        </Grid>
      </Grid>
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </Box>
  )
}

export default Form